export const componentNameConstants = {
  SCRIP_OVERVIEW: "scrip_overview",
  BREADCRUMB: "breadcrumb",
  FAQ: "faq",
  // ✅ Existing
  STOCK_MODAL: "stock_modal",
  STOCK_FUNDAMENTALS: "stock_fundamentals",
  SCRIP_FINANCIALS: "scrip_financials", // Info Icon click tracking
  STOCK_PERFORMANCE: "stock_performance", // ✅ Added for Stock Performance section
  MARKET_SECURITIES: "market_securities",
  FOOTER_COMPONENT: "footer",
  HeaderSignIn: "HeaderSignIn",
  HEADER_NOTIFICATION: "header_notification",
  SIGN_IN_WITH_DESCRIPTION: "sign_in_with_description",

  // ✅ Newly added
  SUBSCRIPTION_CARD_CAROUSEL: "subscription_card_carousel",
  STOCK_LIST_CARD: "stock_list_card",
  STOCKS_SORT_BY: "stocks_sort_by",
  STOCKS_FILTER: "stocks_filter",

  // ✅ Trading Mall components
  STOCK_INFO: "stock_info",
  SIMILAR_STOCKS: "similar_stocks",
  OPEN_DEMAT_BUTTON: "open_demat_button",
  TECHNICAL_SUMMARY: "technical_summary",
  SHAREHOLDING_PATTERN: "shareholding_pattern",
  STOCK_PERFORMANCE_GRAPH: "stock_performance_graph",

  IPO_SIGN_TEXT: "Content_Cards_Information_Descriptive_Content_List",
  IPO_LIST: "IPO_Card_SKU_Descriptive",
  TRADING: "Trading",
  MTF: "MTF",
  EASY_ACCESS: "easy_access",
  BANNER_CAROUSEL: "banner_carousel",

  // ✅ New added, Corporate Actions component
  CORPORATE_ACTIONS: "corporate_actions",
  PORTFOLIO_NAME: "PORTFOLIO_PAGE",
  MARKET_TODAY: "market_today",
  VIEW_MARKETS: "View_Markets",
  SHARE_MARKET_TODAY: "Share_market_today",
  TOP_CATEGORIES: "top_categories",
  VIEW_ALL_CATEGORIES: "View_All_Categories",
  MOST_BOUGHT_STOCKS: "most_bought_stocks",
  MOST_BOUGHT_STOCKS_STOCK_CARD: "most_bought_stocks_stock_card",
  FEATURES_CAROUSEL: "features_carousel",
  FEATURES: "Features",
  TOOLS: "Tools",
  REWARDS: "Rewards",
  ADITIONAL_SERVICES: "Aditional_Services",
  NEWS: "news",
  LEARNING_CENTER: "learning_center",
  IPO_NEWS: "ipo_news",
  TRENDING_NEWS: "Trending",
  OTHER_NEWS: "Other news",
  NEWS_CATEGORY_LISTING: "news_category_listing",
  TABS: "tabs",
  FAILURE_SCENARIOS: "failure_scenarios",
};

export const dlElementConstants = {
  DEMAT_ACCOUNT_CTA: "demat_account_cta",
  SCRIP_OVERVIEW_READ_MORE: "scrip_overview_read_more",
  FAQ_DROPDOWN: "faq_dropdown",
  // ✅ Existing elements
  SCRIP_OVERVIEW_BTN_CLICK: "scrip_overview_button_close",
  SCRIP_OVERVIEW_ICON_CLICK: "scrip_overview_icon_close",
  BREADCRUMB_LINK_CLICK: "breadcrumb_link_click",
  EASY_ACCESS_LINK_CLICK: "easy_access_link_click",
  TRADING_MALL_STOCK_PLP: "TRADING MALL STOCK PLP",
  MARKET_SECURITIES_BTN_CLICK: "market_securities_button_click",
  // ✅ Newly added elements for Stock Fundamentals and Performance DL tracking
  OPEN_ICON: "open_icon",
  INFO_ICON: "info_icon",
  PDP_CLICKED: "TRADINGMALL_DETAILS_SUBMITTED",
  FUNDAMENTALS: "fundamentals",
  FINANCIALS: "financials",
  STOCK_FUNDAMENTALS_BTN_CLICK: "stock_fundamentals_button_close",
  STOCK_FUNDAMENTALS_ICON_CLICK: "stock_fundamentals_icon_close",
  SCRIP_FINANCIALS_BTN_CLICK: "scrip_financials_button_click",
  SCRIP_FINANCIALS_ICON_CLICK: "scrip_financials_icon_click",
  SCRIP_FINANCIALS_TAB_CLICK: "scrip_financials_tab_click",
  TRADING_MALL_STOCK_PDP: "TRADING MALL STOCK PDP",
  STOCKS: "STOCK",
  TAB_CLICK: "tab_click",
  SIGN_IN_WITH_DESCRIPTION_LINK_CLICK: "sign_in_with_description_link_click",
  // ✅ Newly added for Stock Performance
  STOCK_PERFORMANCE: "stock_performance",

  // ✅ Newly added for Subscription Card Carousel
  SUBSCRIPTION_CARD_CAROUSEL_CTA: "subscription_card_carousel_cta",

  // ✅ Trading Mall specific elements
  OPEN_DEMAT_BUTTON: "Open_Demat_Button",
  OPEN_DEMAT_BUTTON_SUBMIT: "open_demat_button_submit",
  CLOSE_ICON: "close_icon",
  CAROUSEL_ARROW_PREV_ICON: "carousel_arrow_prev_icon",
  CAROUSEL_ARROW_NEXT_ICON: "carousel_arrow_next_icon",
  SIMILAR_STOCKS_CARD_CLICK: "similar_stocks_card_click",
  TECHNICAL_SUMMARY_TAB_CLICK: "technical_summary_tab_click",
  SHAREHOLDING_PATTERN_TAB_CLICK: "shareholding_pattern_tab_click",
  SHAREHOLDING_PATTERN_BUTTON_CLICK: "shareholding_pattern_button_click",
  STOCK_LIST_VIEW_ALL_CLICK: "Stock_list_view_all_click",
  STOCK_PERFORMANCE_GRAPH_DURATION_BTN: "stock_performance_graph_duration_btn",
  NOTIFICATION_DELETE_ICON: "notification_delete_icon",
  NOTIFICATION_BELL_ICON: "notification_bell_icon",
  FOOTER_GO_TO_TOP: "footer_go_to_top",
  PLP_CLICKED: "PLP_CLICKED",
  TRADING_MALL_IPO_PLP: "TRADING MALL IPO PLP",
  DISCLAIMER_STRIP: "disclaimer_strip",
  BANNER_CAROUSEL_CTA: "banner_carousel_cta",
  CLP_CLICK: "CLP Click",
  MTF_CLP: "MTF CLP",
  TRADING: "Trading",
  MTF_CLP_EP: "MTF CLP EP",
  TRADING_MALL_CLP_EP: "Trading Mall CLP EP",
  MTF_TAB_CLICK: "MTF Tab Click",
  TRADING_TAB_CLICK: "Trading Tab Click",

  // ✅ New added, Corporate Actions component
  CORPORATE_ACTIONS_CTA_CLICK: "corporate_actions_cta_click",
  VIEW_ALL_CLICK: "view_all_click",
  TRADING_MALL_CLP: "trading_mall_clp",
  VIEW_MARKETS: "vie_markets",
  TOP_CATEGORIES_TAB_CLICK: "top_categories_tab_click",
  WATCH_LIST_ICON_CLICK: "watch_list_icon_click",
  NEWS_TAB_CLICK: "news_tab_click",

  // ✅ Stock PLP sort-by interactions
  STOCKS_SORT_BY_ICON_CLICK: "stocks_sort_by_icon_click",
  STOCKS_SORT_BY_DROPDOWN_CLICK: "stocks_sort_by_dropdown_click",
  STOCKS_SORT_BY_APPLY_CLICK: "stocks_sort_by_apply_click",
  STOCKS_SORT_BY_CANCEL_CLICK: "stocks_sort_by_cancel_click",

  // ✅ Stock PLP filter sidebar (parity with legacy StocksFilter)
  STOCKS_FILTER_CHECKBOX_CLICK: "stocks_filter_checkbox_click",
  STOCKS_FILTER_TAB_CLICK: "stocks_filter_tab_click",
};

export enum dlEventConstants {
  IMAGE_CLICK = "image_click",
  VIDEO_CLICK = "video_click",
  CLICK = "click",
  BUTTON_CLICK = "button_click",
  OPTION_SELECTION = "option_selection",
  SELECTION_CLICK = "selection_click",
  TAB_CLICK = "tab_click",
  // ✅ Newly added event types
  ICON_CLICK = "icon_click",
  CHECKBOX_CLICK = "checkbox_click",
  LINK_CLICK = "link_click",
  CARD_ICON = "card_icon",
  ARROW_CLICK = "arrow_click",
  CLOSE = "CLOSE",
  HEADER_CLICK = "header_click",
  TEXT_CLICK = "text_click",
  CARD_CLICK = "card_click",
  FINANCIALS_CARD_CLICK = "financials_card_click",
  BANNER_CLICK = "banner_click",
  REPORTS_CLICK = "REPORTS_CLICK",
  VIEW_MARKETS = "View_Markets",
  IPO_NEWS_LINK_CLICK = "ipo_news_link_click",
  IPO_NEWS_CARD_CLICK = "ipo_news_card_click",
  NEWS_CATEGORY_LISTING_LINK_CLICK = "news_category_listing_link_click",
  NEWS_CATEGORY_LISTING_BUTTON_CLICK = "news_category_listing_button_click",
  TABS_TAB_CLICK = "tabs_tab_click",
  FAILURE_SCENARIOS_BUTTON_CLICK = "failure_scenarios_button_click",
  LEARNING_CENTER_ICON_CLICK = "learning_center_icon_click",
  TRADINGMALL_DETAILS_SUBMITTED = "TRADINGMALL_DETAILS_SUBMITTED"
}

export const dlCtaTextConstants = {
  CLOSE_ICON: "close_icon",
  LEFT_ARROW: "left_arrow",
  RIGHT_ARROW: "right_arrow",
  // ✅ Newly added CTA text
  READ_MORE: "read_more",
  SHOW_MORE: "show_more",
  SUBSCRIBE_NOW: "subscribe_now",
  FILTERS: "Filters1",
  APPLY: "Apply",
};

// ✅ Trading Mall section titles
export const dlSectionTitleConstants = {
  OPEN_DEMAT_ACCOUNT: "Open Demat Account",
  SIMILAR_STOCKS: "Similar Stocks",
  STOCK_FINANCIALS: "Stock Financials",
  TECHNICAL_SUMMARY: "Technical Summary",
  SHAREHOLDING_PATTERN: "Shareholding Pattern",
  STOCK_PERFORMANCE: "Stock Performance",
  STOCK_LIST: "Stock List",
};

// ✅ CleverTap event names
export const cleverTapEventNames = {
  CAROUSEL_ARROW_PREV_ICON: "carousel_arrow_prev_icon",
  CAROUSEL_ARROW_NEXT_ICON: "carousel_arrow_next_icon",
  SIMILAR_STOCKS_CARD_CLICK: "similar_stocks_card_click",
};

// ✅ CleverTap journey names
export const cleverTapJourneyNames = {
  TRADING_MALL_STOCK_PDP: "TRADING MALL STOCK PDP",
  TRADING_MALL_STOCK_PLP: "TRADING MALL STOCK PLP",
};

// ✅ CleverTap article names
export const cleverTapArticleNames = {
  FINANCIALS: "FINANCIALS",
  TECHNICAL_SUMMARY: "TECHNICAL SUMMARY",
  SHAREHOLDING_PATTERN: "SHAREHOLDING PATTERN",
};

// ✅ Header analytics constants
export const headerConstants = {
  // Element constants
  ELEMENTS: {
    NOTIFICATION_CLOSE_ICON: "notification_close_icon",
    HEADER_SIGN_IN_ICON: "Header sign in icon",
    HEADER_EMI_ICON: "header_emi_icon",
    HEADER_CART_ICON: "Header Cart icon",
    HEADER_REWARDS_ICON: "Header Rewards icon",
    HEADER_PARTNER_ICON: "Header Partner icon",
    TOP_NAVIGATION_SIDEBAR: "top_navigation_sidebar",
    SEARCH_BACK_ICON: "back icon",
    SEARCH_ICON: "search icon",
    SEARCH_SUGGESTION: "search suggestion",
    CROSS_ICON: "cross icon",
  },

  // Component constants
  COMPONENTS: {
    HEADER: "header",
    HEADER_CART: "HeaderCart",
    HEADER_REWARD: "HeaderReward",
    HEADER_PARTNER: "HeaderPartner",
    TOP_NAVIGATION: "top_navigation",
    SEARCH_BANNER: "search_banner",
    SEARCH_BAR: "search_bar",
    SEARCH_RESULT_PAGE: "search_result_page",
  },

  // Event name constants
  EVENT_NAMES: {
    NOTIFICATION_DELETE_ICON: "NOTIFICATION_DELETE_ICON",
    NOTIFICATION_BELL_ICON: "NOTIFICATION_BELL_ICON",
    NOTIFICATION_CLOSE_ICON: "NOTIFICATION_CLOSE_ICON",
    HEADER_SIGN_IN_CLICK: "HEADER_SIGN_IN_CLICK",
    HEADER_EMI_CLICK: "HEADER_EMI_CLICK",
    HEADER_CART_CLICK: "HEADER_CART_CLICK",
    HEADER_REWARDS_CLICK: "HEADER_REWARDS_CLICK",
    HEADER_PARTNER_CLICK: "HEADER_PARTNER_CLICK",
    HEADER_MENU_CLICK: "HEADER_MENU_CLICK",
    HEADER_MENU_CLOSE_CLICK: "HEADER_MENU_CLOSE_CLICK",
    HEADER_MAIN_MENU_CLICK: "HEADER_MAIN_MENU_CLICK",
    HEADER_SIDEBAR_PROFILE_CLICK: "HEADER_SIDEBAR_PROFILE_CLICK",
    HEADER_SIDEBAR_MENU_BUTTON_CLICK: "HEADER_SIDEBAR_MENU_BUTTON_CLICK",
    SEARCH_BACK_CLICK: "SEARCH_BACK_CLICK",
    SEARCH_SUBMIT: "SEARCH_SUBMIT",
    SEARCH_SUGGESTION_CLICK: "SEARCH_SUGGESTION_CLICK",
    SEARCH_HISTORY_DELETE: "SEARCH_HISTORY_DELETE",
  },

  // Section title constants
  SECTION_TITLES: {
    HEADER: "Header",
    HEADER_CART: "Header Cart icon",
    SEARCH: "Search",
    SEARCH_HISTORY: "Search History",
    SEARCH_RESULT: "Search Result",
  },

  // CTA text constants
  CTA_TEXT: {
    NOTIFICATION_CLOSE: "Notification close icon",
    HEADER_SIGN_IN: "Header sign in icon",
    EMI_CARD: "emi_card",
    HEADER_CART: "Header Cart icon",
    PRIME: "Prime",
    PARTNERS: "Partners",
    MENU: "Menu",
    CLOSE_MENU: "Close Menu",
  },

  // Search specific constants
  SEARCH: {
    EVENT_CLICK: {
      ICON_CLICK: "icon_click",
      INPUT_TEXT: "input_text",
      OPTION_SELECTION: "option_selection",
    },
    TARGET: {
      SEARCH_RESULT_REMOVE_OPTION: "search_result_remove_option",
      SEARCH_BANNER_DIRECTION_ICON: "search_banner_direction_icon",
      SEARCH_BAR_INITIATION: "search_bar_initiation",
      SEARCH_BANNER_OPTION_SELECTION: "search_banner_option_selection",
    },
    SUB_SECTION: {
      CROSS_ICON: "cross icon",
    },
  },

  // Mobile Navigation specific constants
  MOBILE_NAVIGATION: {
    ELEMENTS: {
      BOTTOM_NAVIGATION_ICONS: "bottom-navigation-icons",
      BOTTOM_NAVIGATION_MENU: "bottom-navigation-menu",
    },
    COMPONENTS: {
      BOTTOM_NAVIGATION_MOBILE: "bottomNavigationMobile",
    },
    EVENT_TYPES: {
      CARD_CLICK: "card_click",
      ICON_CLICK: "icon_click",
      LINK_CLICK: "link_click",
      SOCIAL_ICON_CLICK: "SOCIAL_ICON_CLICK",
    },
    EVENT_NAMES: {
      BOTTOM_NAV_MENU_CLICK: "BOTTOM_NAV_MENU_CLICK",
      BOTTOM_NAV_ICON_CLICK: "BOTTOM_NAV_ICON_CLICK",
      HAMBURGER_MENU_CLOSE_CLICK: "HAMBURGER_MENU_CLOSE_CLICK",
      HAMBURGER_MENU_CARD_CLICK: "HAMBURGER_MENU_CARD_CLICK",
      CROSS_SELL_LINK_CLICK: "CROSS_SELL_LINK_CLICK",
      HAMBURGER_MENU_LINK_CLICK: "HAMBURGER_MENU_LINK_CLICK",
      SOCIAL_MEDIA_ICON_CLICK: "SOCIAL_MEDIA_ICON_CLICK",
    },
    CTA_TEXT: {
      MENU: "Menu",
      BOTTOM_NAVIGATION_ICONS: "bottom-navigation-icons",
    },
  },
};
